/* eslint-disable no-undef */
import axios from 'axios';

const axiosclient = () => {
	return axios.create({
		baseURL: process.env.GATSBY_PATSTORE_API_URL,
		headers: {
			'X-Parse-Application-Id':  process.env.GATSBY_PATSTORE_APP_ID,
			'X-Parse-REST-API-Key': process.env.GATSBY_PATSTORE_REST_KEY,
			'X-Parse-Master-Key': process.env.GATSBY_PATSTORE_MASTER_KEY,
		}
	});
};

export default axiosclient;
